import React, { Component } from "react";
import Header from "./Header";

class HeaderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: true,
      anchorEl: null,
      right: false
    };
  }

  handleChange = event => {
    this.setState({ auth: event.target.checked });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  toggleDrawer = (side, openDrawer) => () => {
    this.setState({
      [side]: openDrawer
    });
  };

  render() {
    const { auth, anchorEl, right } = this.state;
    const openMenu = Boolean(this.anchorEl);

    return (
      <Header
        open={this.props.open}
        passwordStatus={this.props.passwordStatus}
        daysToPasswordExpiration={this.props.daysToPasswordExpiration}
        passwordExpires={this.props.passwordExpires}
        toggle={this.props.toggle}
        auth={auth}
        anchorEl={anchorEl}
        handleMenu={this.handleMenu}
        handleClose={this.handleClose}
        openMenu={openMenu}
        toggleDrawer={this.toggleDrawer}
        right={right}
      />
    );
  }
}

export default HeaderComponent;
